import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { logger } from '@fiverr-private/obs';
import { PortfolioWidget } from '@fiverr-private/portfolio';
import { SellerPageFederatedSeller, usePortfolio, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { APP_NAME } from '../../../../configuration/constants';
import { useSellerRole } from '../../hooks/useSellerRole';
import { PortfolioTitle } from './PortfolioTitle';

interface RolePagePortfolioProps {
    sellerRoleId?: string;
}

export const RolePagePortfolio: React.FC<RolePagePortfolioProps> = ({ sellerRoleId }) => {
    const { username } = useSellerData(selectSellerSlice);
    const { showPortfolio } = usePortfolio();
    const sellerRole = useSellerRole(sellerRoleId);

    if (!showPortfolio) {
        return null;
    }

    return (
        <>
            <ErrorBoundary onError={onRenderError}>
                <Stack gap="4" direction="column">
                    <PortfolioTitle />
                    <PortfolioWidget
                        username={username}
                        roles={sellerRole ? [{ roleId: sellerRole.role.id, sellerRoleId: sellerRole.id }] : []}
                        roleIds={sellerRole ? [sellerRole.role.id] : []}
                        cardSize={{ md: 'md' }}
                        biEnrichment={{
                            page: {
                                name: APP_NAME,
                            },
                        }}
                        thumbnailsAmount={{
                            sm: 4,
                            md: 6,
                            lg: 5,
                            xl: 6,
                        }}
                        limit={6}
                    />
                </Stack>
            </ErrorBoundary>
        </>
    );
};

const selectSellerSlice = (seller: SellerPageFederatedSeller) => ({
    username: seller.user.name,
});

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the RolePagePortfolio Component');
    logger.error(err, {
        cause: originalError,
    });
};
